import React from 'react';

/**
 * Side area component for signage layout
 * @param {Object} props - Component props
 * @param {Array} props.sideComponents - Side area components
 * @param {Object} props.gridConfig - Grid configuration
 * @param {Function} props.renderGridComponent - Function to render grid components
 * @param {string} props.imageUrl - Image URL
 * @param {Array} props.markers - Markers data
 * @param {Object} props.planData - Plan data
 * @param {Object} props.legacySignage - Legacy signage data
 * @param {Array} props.categoriesData - Categories data for Space Category component
 * @param {string} props.shortName - Short name for dates array
 * @param {Object} props.renderCountRef - Render count reference
 * @returns {JSX.Element} Side area component
 */
const SideArea = ({ 
  sideComponents, 
  gridConfig, 
  renderGridComponent, 
  imageUrl, 
  markers, 
  planData, 
  legacySignage,
  categoriesData,
  shortName,
  renderCountRef 
}) => (
  <div 
    className="signage-side-grid-container"
    style={{ 
      width: `${(1 - gridConfig.dividerRatio) * 100}%`, 
      height: "100%",
      backgroundColor: "#ffffff",
      boxShadow: "rgba(116, 138, 223, 0.25) 0px 0px 30px 4px"
    }}
  >
    {sideComponents.length > 0 ? (
      sideComponents.map((transformedComponent) => {
        renderCountRef.current.sideComponents += 1;
        return renderGridComponent(transformedComponent, imageUrl, markers, planData, false, legacySignage, categoriesData, shortName);
      })
    ) : (
      <div style={{ 
        height: "100%", 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center",
        color: "#6c757d",
        fontSize: "14px"
      }}>
        No side components
      </div>
    )}
  </div>
);

export default SideArea;
